import { ImpersonationModel } from "./impersonation-model";

let model = null;

export function impersonationModel() {
  if (!model) model = new ImpersonationModel();
  return model;
}
